<template>
  <v-col lg="8" align="center">
    <br/><br/>
    <v-row>
      <v-col align="start">
        <h1 class="mb-4">Choose waste type 
          <a style="font-size: 22px; font-weight: lighter;" class="primary--text" @click="show = !show"> - {{show ? 'Hide Info' : 'Waste type info?'}} </a>
        </h1>
      </v-col>
    </v-row>
    <v-row no-gutters class="btn-group" justify="center">
      <v-col cols="4">
        <v-btn
          depressed
          class="primary btn"  
          height="45"
          style="border-radius: 30px;"
          v-on:click="goBack">Go back
        </v-btn>
      </v-col>
    </v-row>
    <br/>
    <v-container>
      <v-row v-for="service in services" v-bind:key="service.key" class="mb-2" justify="center">
        <v-card elevation="10" width="500" v-on:click="service.onClick()" :class="service.isSelected ? 'grey darken-3 primary--text' : 'white black--text'">
          <v-container @click="scrollToTop()">
            <v-row justify="center">     
              <v-col align="center">
                <p>{{ service.name }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-row>
      <v-row v-if="show">
        <v-col>
          <Waste/>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import Waste from '@/components/fast-quote/Waste.vue';
export default {
  name: "WasteType",
  props: {
    proceed: Function,
    wasteTypes: Array,
    goBack: Function
  },
  components:{
    Waste
  },
  data() {
    return {
      services: [],
      selectedServiceType: {},
      canProceed: false,
      show: false
    }
  },
  watch: {
    selectedServiceType () {
      this.canProceed = true;
    }
  },
  methods: {
    scrollToTop(){
      setTimeout(() => {
        scroll(0, 0);
      }, 0)
    },
    selectService(service) {
      this.services.forEach( s =>  {
        s.isSelected = s.key === service;
        if (s.isSelected) {
          this.selectedServiceType = s;
          this.proceed(this.selectedServiceType);
        }
      });
    }

  },
  mounted() {
    this.wasteTypes.forEach( (v) => {
      this.services.push( {...v, isSelected: false, onClick: () => this.selectService(v.key) });
    });
  }
}
</script>

<style scoped>
.btn{
  width: 200px;
}
@media screen and (max-width: 550px){
  .btn-group{
    display: block;
    text-align: start;
  }
  .btn{
    margin-bottom: 0.5cm;
  }

}
</style>